import { updateCurrentCompanySettings } from '@Actions';
import { InputSelect } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { useFormikContext } from 'formik';
import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomInfoCard } from './GeneralSettingsFields.styles';
import { CompanySettingsFull } from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import { useGlobalization } from '@Translations';

export default function DefaultSystemMeasurement() {
	const { t } = useGlobalization();
	const { setValues } = useFormikContext<CompanySettingsFull>();
	const setGeneralSettingsFields = useSetGeneralSettingsFields();
	const companySettingsErrors =
		useSelector(getValue).companySettings.companySettingsErrors || {};
	const dispatch = useDispatch();

	const setCurrentUOMField = (e: ChangeEvent<HTMLInputElement>) => {
		const UOM = e.target.value as 'Metric' | 'Imperial';
		setGeneralSettingsFields({ UOM });
		dispatch(updateCurrentCompanySettings({ UOM }));
		setValues(vals => ({ ...vals, UOM }));
	};

	return (
		<CustomInfoCard fullHeight title={t('Default System of Measurement')}>
			<InputSelect
				menuItems={[
					{
						key: 'Imperial',
						value: 'Imperial',
						label: t('Imperial'),
					},
					{ key: 'Metric', value: 'Metric', label: t('Metric') },
				]}
				fieldAttrs={{ name: 'UOM' }}
				selectProps={{ label: t('Unit Type') }}
				dataCy="unitType"
				onChange={setCurrentUOMField}
				networkError={companySettingsErrors.UOM}
			/>
		</CustomInfoCard>
	);
}
